<form>
  <section class="template-section">
    <h3 class="basic-flex-container">
      <mat-icon fontSet="material-icons-outlined">insert_drive_file_outline</mat-icon>
      {{ forSignature ? 'Signed output ' :''}}{{ outputFileType | titlecase }} type
      {{ multiple ? 'for ' + destination.type + ' destinations' : '' }}
    </h3>
    <div>
      <app-document-type-picker
        [namespace]="workflowConfigNamespace"
        [initialTypeId]="destination?.documentType ?? formGroup.controls['sourceValue'].value"
        [entityType]="destination?.entityTypes[0] ? [destination?.entityTypes[0]] : [entityType]"
        (selected)="documentTypeSelected($event)"
        (keydown.enter)="$event.preventDefault()"
      >
      </app-document-type-picker>
    </div>
  </section>
</form>
